import { useCallback } from 'react';

import {
  Button,
  HexIcon,
  Icons,
  Placeholder,
  PlaceholderProps,
} from '@cast/design-system';
import { openChat } from '@cast/utils';

type Props = Partial<PlaceholderProps> & {
  refresh?: () => void;
  isRefreshing?: boolean;
  compact?: boolean;
  iconSize?: number;
};

export const FailedToLoad = ({
  title = 'Failed to load data',
  body,
  refresh,
  isRefreshing,
  compact,
  iconSize,
  icon = <Icons.Warning weight="fill" />,
  ...rest
}: Props) => {
  const handleRefresh = useCallback(() => {
    if (refresh) {
      refresh();
    } else {
      window.location.reload();
    }
  }, [refresh]);

  return (
    <Placeholder
      icon={
        <HexIcon
          variant="error"
          size={iconSize || (compact ? 34 : 44)}
          icon={icon}
        />
      }
      title={title}
      body={
        body ?? (
          <>
            We&apos;ve got a problem here. Try to refresh the page or reach out
            to our{' '}
            <Button variant="text" onClick={openChat}>
              customer support.
            </Button>
          </>
        )
      }
      actions={
        <Button
          variant="text"
          startIcon={<Icons.ArrowClockwise />}
          onClick={handleRefresh}
          disabled={isRefreshing}
          testId="failed-to-load-retry-button"
        >
          {refresh ? 'Retry' : 'Refresh the page'}
        </Button>
      }
      actionsProps={compact ? { mt: 8 } : undefined}
      testId="failed-to-load"
      {...rest}
    />
  );
};
